import { useEffect, useRef } from "react";
import { X } from "lucide-react";
import { useI18n } from "../../lib/i18n";

export function BidTermsModal({ bidderName, terms, onClose }: { bidderName: string; terms: string; onClose: () => void }) {
  const { t } = useI18n();
  const dialogRef = useRef<HTMLDivElement>(null);

  useEffect(() => { dialogRef.current?.focus(); }, []);

  return (
    <div
      className="fixed inset-0 z-50 bg-black/40 grid place-items-center p-4"
      onClick={onClose}
      onKeyDown={(event) => { if (event.key === "Escape") onClose(); }}
    >
      <div
        ref={dialogRef}
        role="dialog"
        aria-modal="true"
        aria-labelledby="bid-terms-title"
        tabIndex={-1}
        className="card w-full max-w-lg max-h-[85vh] overflow-hidden flex flex-col outline-none"
        onClick={(event) => event.stopPropagation()}
      >
        <div className="flex items-center gap-3 px-5 py-4 border-b border-line">
          <div className="min-w-0">
            <h3 id="bid-terms-title" className="font-bold text-navy">{t("bid.termsExclusions")}</h3>
            <p className="text-xs text-mut truncate">Submitted by {bidderName}</p>
          </div>
          <button type="button" onClick={onClose} className="btn-ghost h-9 w-9 p-0 ml-auto shrink-0" aria-label="Close terms and exclusions">
            <X className="w-4 h-4" />
          </button>
        </div>
        <div className="p-5 overflow-y-auto whitespace-pre-wrap break-words text-sm text-navy">{terms}</div>
      </div>
    </div>
  );
}
